import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestPopupComponent } from './component/request-popup/request-popup.component';
import { MaterialModule } from '../material/material.module';
import { WorkspaceCardComponent } from './component/workspace-card/workspace-card.component';
import { DayCountPipe } from './pipe/day-count.pipe';
import { FormsModule } from '@angular/forms';
import { InvitePopupComponent } from './component/invite-popup/invite-popup.component';
import { FilterPipe } from './pipe/filter.pipe';
import { CardHoverDirective } from './directive/card-hover.directive';
import { WorkspaceFilterPipe } from './pipe/workspace-filter.pipe';
import { MessagePopupComponent } from './component/message-popup/message-popup.component';
import { ConfirmActionPopupComponent } from './component/confirm-action-popup/confirm-action-popup.component';
import { SafePipe } from './pipe/safe.pipe';
import { DateTimeDifferencePipe } from './pipe/date-time-difference.pipe';
import { DateTimePipe } from './pipe/date-time.pipe';
import { GetEnvironmentPipe } from './pipe/get-environment.pipe';
import { SearchFilterComponent } from './component/search-filter/search-filter.component';

const components = [RequestPopupComponent, WorkspaceCardComponent, DayCountPipe,
  InvitePopupComponent, FilterPipe, CardHoverDirective, WorkspaceFilterPipe, MessagePopupComponent,
  ConfirmActionPopupComponent, SafePipe,DateTimeDifferencePipe,
  DateTimePipe, GetEnvironmentPipe,SearchFilterComponent
]

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
  ],
  exports: [...components]
})
export class SharedModule { }
